import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { RadioButton } from "primereact/radiobutton";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
import storage from "../../Services/Storage";
import { format, subDays } from "date-fns";
import { Calendar } from "primereact/calendar";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import Axios from "../../api/Axios";
import { toast } from "react-toastify";

const FreezedCNFOCReport = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);
    const typeWise = [
        { name: "CN", key: "CN" },
        { name: "FOC", key: "FOC" },
    ];
    const [selectedtypeWise, setSelectedTypeWise] = useState(typeWise[0]);
    //   /api/FreezedCNFOCReport/getfreezedcnfocreportdata
    const cnFocurl = "FreezedCNFOCReport/getfreezedcnfocreportdata?";
    const handleExportExcel = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        let daycount = Math.round(
            (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24)
        );
        if(daycount>90){
            toast.warning("Date range should be within 90 days", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        try {
            setLoadingExcel(true);
            const nonInvrptApi = `${cnFocurl}strType=${selectedtypeWise.key}&CompId=${auth.CompId}&UserId=${auth.UserId}&FromDate=${fromDateRange}&EndDate=${toDateRange}`;
            let dataresponse = await Axios.get(nonInvrptApi);
            let uniqueNo = `FreezedCNFOCData${GetDateFormat()}.xlsx`;
            if (dataresponse?.data?.Data.length == 0) {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            } else {
                downloadExcel(dataresponse.data.Data, uniqueNo);
                setLoadingExcel(false);
            }
        } catch (error) {
            setLoadingExcel(false);
            console.log(error);
        }
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Freezed CN/FOC Report</h3>
                    </div>
                    {/* <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="float-end mb-2">
              <button type="submit" className="btn btn-primary">
                <Fa.FaFileExport className="ms-2" /> Export
              </button>
            </div>
          </div> */}
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 mb-3 bottomBorder pb-3 ">
                                {/* <label className="form-label d-block mb-3">Credit Note</label> */}
                                <div className="d-inline-flex">
                                    {typeWise.map((doc) => {
                                        return (
                                            <div key={doc.key} className="flex align-items-center">
                                                <RadioButton
                                                    inputId={doc.key}
                                                    name="doc"
                                                    value={doc}
                                                    onChange={(e) => setSelectedTypeWise(e.value)}
                                                    checked={selectedtypeWise.key === doc.key}
                                                />
                                                <label htmlFor={doc.key} className="mx-2">
                                                    {doc.name}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12"></div>
                            <form>
                                <div className="row d-flex justify-content-end align-items-end">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <label className="form-label">From Date</label>
                                        <Calendar
                                            onChange={(e) => setFromDate(e.value)}
                                            showIcon
                                            value={fromDate}
                                            min="2010-01-01"
                                            dateFormat="dd/mm/yy"
                                            showMinMaxRange={true}
                                        />
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <label className="form-label">To Date</label>
                                        <Calendar
                                            value={toDate}
                                            onChange={(e) => setToDate(e.value)}
                                            showIcon
                                            min="2010-01-01"
                                            dateFormat="dd/mm/yy"
                                            showMinMaxRange={true}
                                        />
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleExportExcel}
                                                disabled={loadingExcel}
                                            >
                                                {loadingExcel ? "Loading..." : "Save as Excel"}{" "}
                                                {loadingExcel ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                ) : (
                                                    <Fa.FaFileExport className="ms-2" />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </form>
                </section>
                {/* <section className="mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">List of Schemes</h3>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    // value={custData}
                                    // tableStyle={{ minWidth: "60rem" }}
                                    rows={10}
                                    filterDisplay="row"
                                    // showGridlines
                                    stripedRows
                                    selectionMode="checkbox"
                                    scrollHeight="80vh"
                                    scrollable
                                    // selection={selectedCustomer}
                                    // onSelectionChange={(e) => {
                                    //     setSelectedCustomer(e.value);
                                    // }}
                                >
                                    <Column
                                        header="Select All"
                                        selectionMode="multiple"
                                        headerStyle={{ width: "5rem" }}
                                    ></Column>
                                    <Column
                                        field=""
                                        header="Customers Name"
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    ></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        </>
    );
};

export default FreezedCNFOCReport;
